import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useSite } from '../../context/SiteContext';
import './Hero.css';

const Hero = () => {
  const { siteName } = useSite();
  const heroRef = useRef(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return undefined;
    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width - 0.5) * 8;
      const y = ((e.clientY - rect.top) / rect.height - 0.5) * 5;
      el.style.setProperty('--parallax-x', `${x}px`);
      el.style.setProperty('--parallax-y', `${y}px`);
    };
    el.addEventListener('mousemove', onMove);
    return () => el.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <section className="hero" ref={heroRef}>
      <div className="hero-media" aria-hidden="true">
        <img
          src="https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=1800"
          alt=""
          className="hero-media-image"
        />
        <div className="hero-media-wash" />
      </div>

      <div className="hero-content">
        <p className="hero-brand">{siteName}</p>
        <h1 className="hero-headline">New season. Better prices.</h1>
        <p className="hero-lede">
          Women, men, shoes &amp; home — fresh markdowns updated daily.
        </p>
        <div className="hero-actions">
          <Link to="/sale" className="hero-cta hero-cta--primary">
            Shop today’s deals
            <ArrowRight size={18} strokeWidth={2.2} />
          </Link>
          <Link to="/shop" className="hero-cta hero-cta--ghost">
            Browse all
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
